const config = {
     // For local development - uncomment these and comment out the env vars below
     //API_BASE_URL: 'http://127.0.0.1:5000/api',
     //WS_BASE_URL: 'ws://127.0.0.1:5000',
     
     // For production/dev server - comment out local URLs above and uncomment these
     API_BASE_URL: process.env.REACT_APP_API_BASE_URL || 'https://backend.nimbleparkdev.in/api',
     WS_BASE_URL: process.env.REACT_APP_WS_BASE_URL || 'ws://backend.nimbleparkdev.in',
     // Google OAuth Client IDs - Different for each platform
     GOOGLE_CLIENT_ID_WEB: process.env.REACT_APP_GOOGLE_CLIENT_ID_WEB || '843513986938-lf9ncdb0gsqm7gkdv299mts2rkhaqnm5.apps.googleusercontent.com',
     GOOGLE_CLIENT_ID_ANDROID: process.env.REACT_APP_GOOGLE_CLIENT_ID_ANDROID || '843513986938-o5qfhiptco4p9r5ss5qga0kffndp4qd0.apps.googleusercontent.com',
     GOOGLE_CLIENT_ID_IOS: process.env.REACT_APP_GOOGLE_CLIENT_ID_IOS || '843513986938-d4r5q8e7d3sohfr5ml2mjfdtqadftcd7.apps.googleusercontent.com',
     // Server Client ID (for backend token verification - usually same as web)
     GOOGLE_SERVER_CLIENT_ID: process.env.REACT_APP_GOOGLE_SERVER_CLIENT_ID || '843513986938-lf9ncdb0gsqm7gkdv299mts2rkhaqnm5.apps.googleusercontent.com',
     // Google Maps API Key
     GOOGLE_MAPS_API_KEY: process.env.REACT_APP_GOOGLE_MAPS_API_KEY || 'AIzaSyDjbyp_nJrwoR_McJoaAWB8thRNMrQu7Ew',
     // Facebook App ID for customer login (web). Native (Android/iOS) deferred to phase 2.
     FACEBOOK_APP_ID: process.env.REACT_APP_FACEBOOK_APP_ID || '',
     // Sign in with Apple — Services ID (web) and redirect URI registered in
     // Apple Developer console. Native (iOS) flow deferred to phase 2.
     APPLE_CLIENT_ID: process.env.REACT_APP_APPLE_CLIENT_ID || '',
     APPLE_REDIRECT_URI: process.env.REACT_APP_APPLE_REDIRECT_URI || ''
};

export default config; 